'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const FAQS = [
  {
    id: 'faq-001',
    q: 'Can I cancel my subscription at any time?',
    a: 'Yes. You can cancel anytime from your account settings. If you cancel a monthly subscription, you retain access until the end of your billing period. Annual subscribers receive a prorated refund for unused months.',
  },
  {
    id: 'faq-002',
    q: 'What formats do the lesson downloads come in?',
    a: 'Every lesson includes a print-ready PDF, an editable Google Slides presentation, and student-facing handout PDFs. Teacher Pro and School subscribers also get editable Google Docs versions of all worksheets.',
  },
  {
    id: 'faq-003',
    q: 'How does Google Classroom / Canvas integration work?',
    a: 'Click "Assign to LMS" on any lesson page. You\'ll be redirected to your LMS with the lesson pre-loaded as a new assignment — including the Google Slides link, student handouts, and instructions. No copy-pasting required.',
  },
  {
    id: 'faq-004',
    q: 'Is the content culturally responsive and bias-reviewed?',
    a: 'Yes. Every lesson is reviewed by our educator advisory panel, which includes teachers from diverse cultural backgrounds and curriculum equity specialists. We update lessons based on community feedback and emerging research.',
  },
  {
    id: 'faq-005',
    q: 'What grade levels do your lessons cover?',
    a: 'Lessons span Grades 3–12, organized into three bands: Elementary (3–5), Middle School (6–8), and High School (9–12). Many lessons include differentiation notes for adapting to multiple grade levels.',
  },
  {
    id: 'faq-006',
    q: 'How does the School License work?',
    a: 'A School License covers all teachers at a single campus. An admin receives a dashboard to onboard teachers, track usage, and generate reports. Pricing is based on school size — contact us for a custom quote.',
  },
];

export default function SubscriptionFAQ() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <div className="bg-white py-16">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-display text-3xl font-bold text-stone-800 mb-2">
              Frequently Asked Questions
            </h2>
            <p className="text-stone-500 text-sm">
              Still have questions?{' '}
              <a href="mailto:hello@teachglobal.edu" className="text-primary-600 hover:underline">
                Email us anytime.
              </a>
            </p>
          </div>

          <div className="space-y-2">
            {FAQS?.map((faq) => (
              <div
                key={faq?.id}
                className="border border-stone-200 rounded-2xl overflow-hidden"
              >
                <button
                  onClick={() => setOpenId(openId === faq?.id ? null : faq?.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-stone-50 transition-colors duration-150"
                  aria-expanded={openId === faq?.id}
                >
                  <span className="font-medium text-stone-800 text-sm pr-4">{faq?.q}</span>
                  <Icon
                    name={openId === faq?.id ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                    size={18}
                    className={`flex-shrink-0 transition-transform duration-200 ${
                      openId === faq?.id ? 'text-primary-600' : 'text-stone-400'
                    }`}
                  />
                </button>
                {openId === faq?.id && (
                  <div className="px-5 pb-5 text-sm text-stone-600 leading-relaxed border-t border-stone-100 animate-fade-in">
                    <div className="pt-4">{faq?.a}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}